import React, { useState } from "react";
import "../../assets/css/catalogue.css";
import { useSelector } from "react-redux";
import { generateCataloguePdf } from "./service/pdf.service";

const CatalogComponent = ({
  products = [],
  selectedFilters = {},
  search = "",
}) => {
  const [loading, setLoading] = useState(false);

  // =====================================================
  // GET ROLE FROM REDUX
  // =====================================================
  const reduxRoleId = useSelector(
    (state) => state.auth?.user_role_id
  );

  // =====================================================
  // GET ROLE FROM LOCAL STORAGE
  // =====================================================
  const localRoleId =
    localStorage.getItem("user_role_id");

  // =====================================================
  // FINAL ROLE
  // Redux first, LocalStorage fallback
  // =====================================================
  const userRoleId =
    reduxRoleId !== undefined &&
    reduxRoleId !== null &&
    reduxRoleId !== ""
      ? reduxRoleId
      : localRoleId;

  // =====================================================
  // NORMALIZE ROLE
  // =====================================================
  const roleId = Number(userRoleId);

  // =====================================================
  // ROLE 5 = SHOW CATALOGUE
  // ANY OTHER ROLE = HIDE
  // =====================================================
  if (roleId !== 5) {
    return null;
  }

  // =====================================================
  // FILE NAME
  // =====================================================
  const getFileName = () => {
    const firstProduct = products?.[0];

    let name =
      firstProduct?.quality_name ||
      firstProduct?.designshade ||
      "products";

    name = String(name)
      .trim()
      .replace(/[\\/:*?"<>|]/g, "_")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_");

    return `${name}-products.pdf`;
  };

  // =====================================================
  // DOWNLOAD PDF BLOB
  // =====================================================
  const downloadPdfBlob = (blob, fileName) => {
    if (!blob) {
      throw new Error("PDF file was not generated.");
    }

    const pdfBlob = new Blob([blob], {
      type: "application/pdf",
    });

    const url =
      window.URL.createObjectURL(pdfBlob);

    const link =
      document.createElement("a");

    link.href = url;
    link.download = fileName;

    // Important for browser download
    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    link.remove();

    // Release object URL after browser starts download
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 500);
  };

  // =====================================================
  // GENERATE PDF
  // =====================================================
  const handleDownloadPDF = async () => {
    // Prevent multiple clicks
    if (loading) {
      return;
    }

    // Validate products
    if (
      !Array.isArray(products) ||
      products.length === 0
    ) {
      alert("Product data not available");
      return;
    }

    try {
      setLoading(true);

      // =================================================
      // PREPARE PAYLOAD
      // =================================================
      const payload = {
        products,

        search: search || "",

        filters: {
          design: Array.isArray(
            selectedFilters?.design
          )
            ? selectedFilters.design
            : [],

          shade: Array.isArray(
            selectedFilters?.shade
          )
            ? selectedFilters.shade
            : [],

          size: Array.isArray(
            selectedFilters?.size
          )
            ? selectedFilters.size
            : [],

          shape: Array.isArray(
            selectedFilters?.shape
          )
            ? selectedFilters.shape
            : [],

          price:
            selectedFilters?.price || "",
        },

        total_products: products.length,

        generated_at:
          new Date().toISOString(),
      };

      console.log(
        "CATALOGUE PDF PAYLOAD:",
        payload
      );

      // =================================================
      // CALL PDF API
      // =================================================
      const pdfBlob =
        await generateCataloguePdf(payload);

      // =================================================
      // DOWNLOAD
      // =================================================
      downloadPdfBlob(
        pdfBlob,
        getFileName()
      );
    } catch (error) {
      console.error(
        "PDF GENERATION ERROR:",
        error
      );

      alert(
        error?.message ||
          "Failed to generate catalogue PDF"
      );
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // DISABLED STATE
  // =====================================================
  const disabled =
    loading ||
    !Array.isArray(products) ||
    products.length === 0;

  // =====================================================
  // UI
  // =====================================================
  return (
    <div className="catalog-btn">
  <button
    type="button"
    className="catalog-pdf-button"
    onClick={handleDownloadPDF}
    disabled={disabled}
    aria-label={
      loading
        ? "Generating PDF"
        : "Download PDF"
    }
  >
    {loading ? (
      <span
        className="catalog-spinner"
        aria-hidden="true"
      />
    ) : (
      <svg
        className="catalog-pdf-svg"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* =================================
            LIGHT GRAY CIRCULAR ARROW
        ================================= */}

        <path
          d="
            M72 18
            H43
            C28 18 18 29 18 43
            V58
          "
          fill="none"
          stroke="#bdbdbd"
          strokeWidth="8"
          strokeLinecap="square"
        />

        <path
          d="
            M18 43
            V58
            H33
          "
          fill="none"
          stroke="#bdbdbd"
          strokeWidth="8"
          strokeLinecap="square"
        />

        <path
          d="
            M28 70
            H57
            C72 70 82 59 82 45
            V32
          "
          fill="none"
          stroke="#bdbdbd"
          strokeWidth="8"
          strokeLinecap="square"
        />

        {/* =================================
            PDF RED BADGE
        ================================= */}

        <rect
          x="8"
          y="29"
          width="51"
          height="31"
          rx="5"
          fill="#ff1010"
        />

        {/* PDF text */}

        <text
          x="33.5"
          y="51"
          textAnchor="middle"
          fontFamily="Arial, Helvetica, sans-serif"
          fontSize="22"
          fontWeight="800"
          fill="#ffffff"
        >
          PDF
        </text>

        {/* =================================
            DOWNLOAD ARROW
        ================================= */}

        <path
          d="
            M68 47
            H82
            V65
            H91
            L75 84
            L59 65
            H68
            Z
          "
          fill="#ff1010"
        />
      </svg>
    )}
  </button>
</div>
  );
};

export default CatalogComponent;

